import datagridLocales from "./datagrid-locales";

const dataGridLocalize = (language_id) => {
  return language_id in datagridLocales
    ? datagridLocales[language_id]
    : datagridLocales["en"];
};

export default dataGridLocalize;
